<template>
  <div class="modal fade modal-feature-type" :id="modalId" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div v-if="viewType === 1" class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 class="title-modal">{{ selectOnly ? 'Funcionalidades do boleto' : 'Gerar Venda' }}</h5>
        </div>

        <div class="modal-body">
          <p v-if="selectOnly" class="select-only-hint">Selecione as funcionalidades que a empresa vai pagar neste boleto.
            A seleção é opcional.</p>
          <div v-if="!selectOnly" class="list-info">
            <p>Começa em: <span>{{ dataFeature.startAt | formatDate }}</span></p>
            <p>Expira em: <span>{{ dataFeature.expireAt | formatDate }}</span></p>
            <p>Total de funcionários: <span>{{ dataFeature.totalEmployeeHr }}</span></p>
            <p>Valor por funcionário: <span>R{{ dataFeature.pricePerEmployeeHr | currency }}</span></p>
            <p v-if="dataFeature.totalEmployeeBeneflex">Funcionários com beneflex:
              <span>{{ dataFeature.totalEmployeeBeneflex }}</span></p>
            <p v-if="dataFeature.totalEmployeeBeneflex">Valor por
              funcionário(Beneflex)<span>R{{ dataFeature.pricePerEmployeeBeneflex }}</span></p>
            <p>Preço de cobrança: <span>R{{ dataFeature.priceToCharge | currency }}</span></p>
            <p>Preço recorrente: <span>R{{ dataFeature.recurringPrice | currency }}</span></p>
            <p>Dia recorrente: <span>{{ dataFeature.recurringDay }}</span></p>
            <p>Nota?: <span v-if="dataFeature.generateInvoice">Sim</span><span v-else>Não</span></p>
            <p v-if="dataFeature.invoiceDate">Data de emissão: <span>{{ dataFeature.invoiceDate | formatDate }}</span>
            </p>
            <p v-if="dataFeature.invoiceNotes">Observaçaõ da nota: <span>{{ dataFeature.invoiceNotes }}</span></p>
          </div>
          <div class="loading-btn" v-if="loadingFeature">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
          <div v-if="modalOpen" class="col-xs-12 col-sm-12 col-md-12 padding-null plans">
            <div v-if="!selectOnly" class="col-md-12 feature-type-plans">
              <span>Plano: </span>
              <span v-if="dataFeature.planId === '006AE79EAC754C518548BC5F05B77CF2'">Essencial</span>
              <span v-else-if="dataFeature.planId === '00875CC4401649EEB36F253AB234525E'">Básico</span>
              <span v-else-if="dataFeature.planId === '00AD8417796E41269871612954AA8696'">Profissional</span>
              <span v-else-if="dataFeature.planId === '012ABCA6249047FFA16A9B2818E20A2F'">Premium</span>
              <span v-else-if="dataFeature.planId === '8B3B929E51BD4EB7ACEB7835BA57A5F0'">Plano 1</span>
              <span v-else-if="dataFeature.planId === 'E7D021FA8B0B441791F20E2149541F94'">Plano 2</span>
              <span v-else-if="dataFeature.planId === 'EE7BC5B1195A41E5B6394FA4CA4E46BF'">Plano 3</span>
              <span v-else>Desconhecido</span>

            </div>

            <div class="col-md-12 feature-picker">
              <feature-module-picker :options="options" v-model="selectedIds"/>
            </div>
          </div>

          <!--                    <div v-on:click="d.isSelected = !d.isSelected" v-for="d in featureList" class="checkbox inline-block"-->
          <!--                         v-bind:class="{'inline-checked': d.isSelected}">-->
          <!--                      <input v-bind:id="d.featureId" type="checkbox" v-model="d.isSelected"-->
          <!--                             v-on:click="d.isSelected = !d.isSelected">-->
          <!--                      <label>{{ d.name }}</label>-->
          <!--                    </div>-->
        </div>

        <div class="modal-footer">
          <button v-on:click="checkFeatures()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">{{ selectOnly ? 'Gerar boleto' : 'Salvar' }}</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>

      <div v-if="viewType === 2" class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 class="title-modal">Boleto gerado com sucesso.</h5>
        </div>

        <div class="modal-body">
          <div class="list-info">
            <p class="link-payment">Link: <span><a v-bind:href="uriBoleto" target="_blank">{{ uriBoleto }}</a></span>
            </p>
          </div>
          <div class="modal-footer">
            <button v-on:click="closeModal()" class="close-btn">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CHANGE_FINANCIAL_EMAIL,
  FEATURE_PLAN, GET_FEATURES,
  PAYMENT,
  SALES_INFORMATION,
  SALES_REPORT_ERROR
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../utils";
import swal from "sweetalert";
import featureModulePicker from "../components/default/featureModulePicker.vue";
import { enabledIds, toPickerOptions } from "./featureOptions";

export default {
  name: "modalFeatureType",
  // selectOnly: o modal so escolhe. "Salvar" devolve os ids no evento
  // `selected` em vez de postar a venda. modalId existe porque
  // companyDetail.vue ainda chama $("#modalFeatureType") no fluxo de venda.
  props: {
    objToModal: {},
    selectOnly: { type: Boolean, default: false },
    modalId: { type: String, default: 'modalFeatureType' }
  },
  components: { featureModulePicker },
  data() {
    return {
      modalOpen: false,
      viewType: 1,
      options: [],
      selectedIds: [],
      dataFeature: {},
      context: '',
      resetInputs: '',
      uriBoleto: '',
      loadingChange: false,
      loadingFeature: false,
      lastSaleError: null
    }
  },
  watch: {
    objToModal: function (val) {
      this.viewType = 1;
      this.dataFeature = val;
      this.context = val.context;
      this.loadDataPlan(val.planId, val.context);
    },
    resetInputs: function (val) {
      this.$emit('update:resetInputPayment', val)
    },
    uriBoleto: function (val) {
      this.$emit('update:reloadFunction', val)
    },
  },
  methods: {
    checkFeatures() {
      if (this.selectOnly) {
        this.$emit('selected', this.selectedIds.slice());
        this.closeModal();
        return;
      }

      if (this.loadingChange) return;
      this.loadingChange = true;
      this.dataFeature.featureIds = `[${this.selectedIds}]`;
      UTIL_SERVICE.console("data send:", this.dataFeature);
      REQUEST_SERVICE.requestContext('POST', SALES_INFORMATION, this.context, this.dataFeature).then((response) => {
        UTIL_SERVICE.console("RESULT PAYMENT:", response.data);
        this.loadingChange = false;
        this.uriBoleto = response.data;
        this.resetInputs = Math.floor(Math.random() * 101);
        this.viewType = 2;
        swal("Aviso", "Boleto gerado com sucesso", "success").then(() => {
          location.reload();
        });
      }).catch((reason) => {
        this.loadingChange = false;
        this.lastSaleError = this.buildSaleErrorReport(reason);
        this.closeModal();
        this.showSaleError(this.lastSaleError);
      });
    },
    loadDataPlan(planId, context) {
      let url = FEATURE_PLAN + planId;
      this.loadingFeature = true;
      REQUEST_SERVICE.requestContext('GET', GET_FEATURES, context).then((response) => {
        UTIL_SERVICE.console("RESULT FEATURE_PLAN:", response.data);

        this.options = toPickerOptions(response.data);
        this.selectedIds = enabledIds(response.data);

        this.loadingFeature = false;
        this.modalOpen = true

      }).catch((reason) => {
        this.loadingFeature = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    buildSaleErrorReport(reason) {
      const response = reason && reason.response;
      const config = (reason && reason.config) || (response && response.config) || {};
      const httpResponse = response
        ? {
          status: response.status || 0,
          statusText: response.statusText || '',
          body: response.data === undefined ? null : response.data
        }
        : {
          status: 0,
          statusText: 'Sem resposta do servidor',
          body: {message: (reason && reason.message) || ''}
        };
      const body = httpResponse.body;
      const trace = body && typeof body === 'object' ? (body.gatewayTrace || body.GatewayTrace) : null;
      const dataFeature = this.dataFeature || {};
      const companyId = dataFeature.companyId || '';
      const shard = this.context || '';
      return {
        companyId: companyId,
        companyName: dataFeature.companyName || '',
        shard: shard,
        masterLink: window.location.origin + '/detalhes-da-empresa/' + companyId + '/' + shard,
        page: window.location.href,
        occurredAt: new Date().toISOString(),
        payload: this.copySalePayload(dataFeature),
        httpRequest: {
          method: String(config.method || 'POST').toUpperCase(),
          url: config.url || SALES_INFORMATION,
          headers: this.sanitizeRequestHeaders(config.headers),
          body: this.parseJsonBody(config.data)
        },
        httpResponse: httpResponse,
        gatewayTrace: Array.isArray(trace) ? trace : [],
        clientUser: this.currentMasterUser()
      };
    },
    copySalePayload(dataFeature) {
      try {
        return JSON.parse(JSON.stringify(dataFeature));
      } catch (e) {
        return {};
      }
    },
    sanitizeRequestHeaders(headers) {
      const blocked = ['authorization', 'up', 'uid', 'cid', 'api_token'];
      const result = {};
      if (!headers || typeof headers !== 'object') return result;
      Object.keys(headers).forEach((key) => {
        const value = headers[key];
        if (blocked.indexOf(key.toLowerCase().replace(/-/g, '_')) !== -1) return;
        if (value === undefined || value === null || typeof value === 'object' || typeof value === 'function') return;
        result[key] = value;
      });
      return result;
    },
    parseJsonBody(data) {
      if (data === undefined) return null;
      if (typeof data !== 'string') return data;
      try {
        return JSON.parse(data);
      } catch (e) {
        return data;
      }
    },
    currentMasterUser() {
      try {
        const user = JSON.parse(window.localStorage.getItem('mamUserMasterInfo')) || {};
        return {id: user.id || '', name: user.name || '', email: user.email || ''};
      } catch (e) {
        return {id: '', name: '', email: ''};
      }
    },
    saleErrorMessage(httpResponse) {
      const status = (httpResponse && httpResponse.status) || 0;
      const body = httpResponse && httpResponse.body;
      if (body && typeof body === 'object') {
        const erros = Array.isArray(body.erros) ? body.erros : [];
        const values = erros.map(e => typeof e === 'string' ? e : (e && (e.value || e.Value))).filter(v => v);
        if (values.length) return values.join("\n");
        const detail = body.ExceptionMessage || (body.exception && body.exception.message) || body.Message;
        if (detail) return detail;
      }
      if (status > 0) return httpResponse.statusText || ("Não foi possível gerar a venda (HTTP " + status + ").");
      return "Falha de comunicação com o servidor";
    },
    showSaleError(report) {
      const status = report.httpResponse.status;
      const options = {
        title: "Ops...",
        text: this.saleErrorMessage(report.httpResponse),
        icon: 'error'
      };
      if (status === 0 || status >= 400) {
        options.buttons = {
          cancel: "Fechar",
          report: {text: "Reportar XND", value: "report", closeModal: false}
        };
      } else {
        options.button = "Fechar";
      }
      swal(options).then((value) => {
        if (value === "report") this.sendSaleErrorReport(report);
      });
    },
    sendSaleErrorReport(report) {
      REQUEST_SERVICE.requestContext('POST', SALES_REPORT_ERROR, report.shard, report).then(() => {
        swal("Aviso", "Reporte enviado para o XND. Pode seguir com o próximo atendimento.", "success");
      }).catch(() => {
        swal({
          title: "Ops...",
          text: "Não consegui enviar o reporte; copie o texto abaixo e mande para o XND",
          icon: 'error',
          content: this.saleErrorSummaryElement(report),
          button: "Fechar"
        });
      });
    },
    saleErrorSummaryElement(report) {
      const summary = {
        companyId: report.companyId,
        companyName: report.companyName,
        shard: report.shard,
        masterLink: report.masterLink,
        occurredAt: report.occurredAt,
        clientUser: report.clientUser,
        httpStatus: report.httpResponse.status,
        message: this.saleErrorMessage(report.httpResponse),
        gatewayTrace: report.gatewayTrace.map(t => t && typeof t === 'object'
          ? {gateway: t.gateway, account: t.account, operation: t.operation, httpStatus: t.httpStatus, error: t.error}
          : t)
      };
      const textarea = document.createElement('textarea');
      textarea.value = JSON.stringify(summary, null, 2);
      textarea.readOnly = true;
      textarea.rows = 12;
      textarea.style.width = '100%';
      textarea.style.fontFamily = 'monospace';
      textarea.style.fontSize = '12px';
      textarea.addEventListener('focus', () => textarea.select());
      return textarea;
    },
    closeModal() {
      $('#' + this.modalId).modal('toggle');
    }
  }
}
</script>

<style lang="scss">
#modalFeatureType, .modal-feature-type {
  @media (min-width: 768px) {
    .modal-dialog {
      width: 900px;
      margin: 30px auto;
    }
  }

  // A lista de modulos pode passar da altura da tela: o corpo rola e o
  // cabecalho e o rodape (com o botao) ficam sempre visiveis.
  .modal-content {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 60px);
  }

  .modal-header,
  .modal-footer {
    flex: 0 0 auto;
  }

  .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
  }

  h4 {
    border-top: 1px solid #eee;
    padding-top: 20px;
    margin-bottom: 20px;
    text-align: left;
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  a {
    margin-bottom: 20px;
    display: block;
    color: #3598dc;
  }

  .list-info {
    padding-top: 10px;

    p {
      display: inline-flex;
      width: calc(100% / 2 - 20px);
      margin: 0 0 20px;

      span {
        display: inline-block;
        margin-left: 4px;
        font-weight: 600;
        overflow-wrap: anywhere;
      }
    }

    .link-payment {
      width: 100%;
    }
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding: 0 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}

.plans {
  margin: 40px 0 50px 0;

  .col-xs-12, .col-sm-12, .col-md-12, {
    padding: 0;
  }

  .first-col {
    padding-left: 0;
  }

  .last-col {
    padding-right: 0;
  }

  .extra-col {
    position: absolute;
    bottom: -78px;

    padding-left: 0;

  }

  .feature-type-plans {
    color: var(--dark-gray);
    font-size: 21px;
    font-weight: 400;

    span {
      font-weight: 700;
    }
  }

  .features-plans {
    display: flex;
    flex-direction: column;

    .modules {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      margin: 16px 0 28px 0;
    }

    .plans-header {
      color: var(--dark-gray);

      .plans-title {
        font-weight: 600;
        font-size: 18px;
        padding-bottom: 8px;
        margin: 16px 0 8px 0;
        border-bottom: 1px solid var(--classic-gray);
      }

      .plans-subtitle {
        font-weight: 700;
        font-size: 14px;
      }
    }

    .new-checkbox {
      position: relative;
      display: flex;
      align-items: center;
      padding: 8.5px 8px;
      border: 1px solid #E6E9EC;
      border-radius: 18px !important;

      .tooltip-feature {
        position: absolute;
        background: #000;
        border-radius: 8px !important;
        font-size: 11px;
        padding: 6px;
        left: 50%;
        top: 50px;
        transform: translateX(-50%);
        max-width: 220px;
        min-width: 200px;
        color: #fff;
        display: none;
        z-index: 9999;

        &:before {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 10px solid black;
          position: absolute;
          top: -9px;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      &:hover {
        .tooltip-feature {
          display: block;
        }
      }

      ion-icon {
        width: 14px;
        min-width: 14px;
        margin-left: auto;
        color: #3a424e80;
      }

      .switch-plans {
        input {
          display: none;
        }

        label {
          display: flex;
          align-items: center;
          width: 34px;
          height: 21px;
          background-color: #E6E9EC;
          position: relative;
          cursor: pointer;
          border-radius: 1.6rem !important;
          margin: 0;

          &::after {
            content: "";
            position: absolute;
            left: .3rem;
            width: 15px;
            height: 15px;
            border-radius: 50% !important;
            background: #9baacf;
            transition: all .4s ease;
          }

          &::before {
            content: "";
            width: 100%;
            height: 100%;
            border-radius: inherit !important;
            background: #2F23D6;
            opacity: 0;
            transition: all .4s ease;
          }
        }
      }

      & input:checked {
        & ~ label {
          &::before {
            opacity: 1;
          }

          &::after {
            left: 1.6rem;
            background: #ffffff;
          }
        }
      }
    }

    .checkbox-label {
      margin: 0 0 0 10px;
      font-weight: 400;
      font-size: 13px;
      color: #3A424E;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalFeatureType.vue